import { ImageMetadataProperty } from "./image-metadata-property";
import { ExifData } from "./inspection-image";

export class ImageMetadata {
  metadata: Map<string, ImageMetadataProperty> = new Map();

  constructor(rawImageMetadata: ExifData) {
    this.metadata = this.convertRawMetadata(rawImageMetadata);
  }

  private convertRawMetadata(rawMetadata: ExifData): Map<string, ImageMetadataProperty> {
    const metadata = new Map<string, ImageMetadataProperty>();
    const exifData = rawMetadata.tags;

    Object.keys(exifData).forEach((key) => {
      const propertyValue = exifData[key];

      if (propertyValue?.description === "[Undefined encoding]" || !("value" in propertyValue)) {
        return;
      }

      if (typeof propertyValue === "object" && propertyValue !== null) {
        if (!this.isAllNullChars(propertyValue.value)) {
          metadata.set(
            key,
            new ImageMetadataProperty(
              propertyValue.value !== null && propertyValue.value !== undefined ? propertyValue.value : "NA",
              propertyValue.description || "NA"
            )
          );
        }
      } else if (propertyValue !== null && propertyValue !== undefined && !this.isAllNullChars(propertyValue)) {
        metadata.set(key, new ImageMetadataProperty(propertyValue.toString(), "NA"));
      }
    });

    return metadata;
  }

  private isAllNullChars(value: any): boolean {
    return typeof value === "string" && /^[\u0000]*$/.test(value);
  }
}
